import type React from 'react';
import { type MutableRefObject } from 'react';
import { Recommendation } from '@features/programs';
import type { ExerciseVideo } from '@shared/types/exercises';
import type { Program, RecommendationT } from '@shared/types/programs';
import { PromoVideo } from '@shared/types/promo-videos';
import type { Mode } from 'library/types/programs';
import { VideoCard } from './frames';
import * as st from './Aside.module.scss';

type Props = {
  // programId: number;
  program: Program;
  mode: Mode;
  onAboutClick: () => void;
  selectedId: number;
  onRecommendationClick: (recommendation: RecommendationT) => void;
  onVideoClick: (video: ExerciseVideo) => void;
  programVideos?: ExerciseVideo[];
  scrollBlockRef: MutableRefObject<HTMLElement | null>;
  currentActiveRecommendation?: RecommendationT;
  getIsVideoAvailableByScheduleFunc: (video: PromoVideo | ExerciseVideo) => boolean;
};

const Aside: React.FC<Props> = ({
  mode,
  selectedId,
  onAboutClick,
  onRecommendationClick,
  currentActiveRecommendation,
  onVideoClick,
  programVideos,
  scrollBlockRef,
  getIsVideoAvailableByScheduleFunc,
  program,
}) => {
  return (
    <section className={st.playlist__list} id="playlist">
      <section className={st.forScroll} ref={scrollBlockRef}>
        {program.promo_video && (
          <>
            <VideoCard
              onClick={onAboutClick}
              imageSrc={program?.promo_video?.screenshot_url}
              title="Трейлер"
              isActive={mode === 'promo'}
            />
            <div className={st.promoLine}></div>
          </>
        )}
        {program?.recommendations &&
          program?.recommendations.map((rec) => (
            <Recommendation
              key={rec.id}
              isActive={mode === 'comment' && currentActiveRecommendation?.id === rec.id}
              onClick={() => onRecommendationClick(rec)}
              recommendation={rec}
            />
          ))}
        {programVideos?.map((video) => {
          const isVideoAvailableBySchedule = getIsVideoAvailableByScheduleFunc(video);
          return (
            <VideoCard
              key={video.id}
              onClick={() => {
                onVideoClick(video);
              }}
              imageSrc={video.screenshot_url}
              isVideoAvailableBySchedule={isVideoAvailableBySchedule}
              title={video.title}
              isActive={!!(selectedId && selectedId === video.id && mode === 'video')}
            />
          );
        })}
      </section>
    </section>
  );
};

export default Aside;
